import { Instagram, Facebook, Phone, MapPin, Clock } from "lucide-react";
import { BUSINESS } from "@/lib/business";
import { ShareButton } from "@/components/ShareButton";

export const Footer = () => {
  return (
    <footer id="contact" data-testid="footer" className="bg-ink text-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={BUSINESS.logo} alt="KitchenBox logo" className="h-14 w-14 rounded-full object-cover ring-1 ring-white/10" />
            <h3 className="font-serif text-2xl font-bold text-white">KitchenBox</h3>
          </div>
          <p className="mt-3 text-cream/70 text-sm">{BUSINESS.tagline}</p>
          <p className="mt-4 text-cream/70 text-sm">Authentic Iraqi &amp; Middle Eastern food & desserts, made fresh to order.</p>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold font-bold">Visit & Hours</h4>
          <ul className="mt-4 space-y-3 text-sm text-cream/80">
            <li className="flex gap-3"><MapPin size={18} className="text-gold shrink-0" /> {BUSINESS.serviceArea}</li>
            <li className="flex gap-3"><Clock size={18} className="text-gold shrink-0" /> {BUSINESS.hours}</li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold font-bold">Get in touch</h4>
          <div className="mt-4 flex flex-col gap-3">
            <a href={BUSINESS.instagramUrl} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-3 text-white rounded-full px-5 py-3 font-bold w-fit bg-gradient-to-tr from-[#feda75] via-[#d62976] to-[#4f5bd5] hover:opacity-90 transition-opacity">
              <Instagram size={18} /> Order on Instagram
            </a>
            <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="footer-phone" className="inline-flex items-center gap-3 text-cream/80 hover:text-white transition-colors">
              <Phone size={18} className="text-gold" /> {BUSINESS.phone} · Call or text
            </a>
            <a href={BUSINESS.instagramUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 text-cream/80 hover:text-white transition-colors">
              <Instagram size={18} className="text-gold" /> @{BUSINESS.instagram}
            </a>
            <a href={BUSINESS.facebookUrl} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="inline-flex items-center gap-3 text-cream/80 hover:text-white transition-colors">
              <Facebook size={18} className="text-gold" /> Find us on Facebook
            </a>
            <ShareButton
              testid="footer-share"
              label="Share KitchenBox"
              className="mt-1 inline-flex items-center gap-3 text-white rounded-full px-5 py-3 font-bold w-fit bg-white/10 hover:bg-white/20 transition-colors"
            />
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center text-xs text-cream/50">
          © {new Date().getFullYear()} KitchenBox · {BUSINESS.city}
        </div>
      </div>
    </footer>
  );
};
